import {CheckboxAloneFactory} from 'plugins/modules/filter/components/CheckboxAloneFactory';
import {BrowserFilters} from 'plugins/modules/filter/helpers/BrowserFilters';
import {getFilterTitleForGtag} from 'plugins/modules/filter/helpers';
import {IFilterFacet} from 'plugins/modules/filter/types';
import React, {FC, useCallback, useMemo} from 'react';
import {isBrowserContext} from 'core/helpers';
import {useFiltersGtag} from 'hooks/analytics/gtag/catalog/useFiltersGtag';
import {EventAction} from 'modules/google-analytics/constants';
import {useFiltersRouterPush} from '../../hooks/useFiltersRouterPush';

interface IProps {
    filter: IFilterFacet;
}

export const CheckboxAloneFilterController: FC<IProps> = ({filter}) => {
    const {pushRoute} = useFiltersRouterPush();

    const sendFiltersGtag = useFiltersGtag();

    const filterInstance = useMemo(() => {
        if (!isBrowserContext()) {
            return null;
        }

        return BrowserFilters.getInstance();
    }, []);

    const variantCode = filter.variants?.[0]?.code;

    const handleApply = useCallback(() => {
        if (!filterInstance) {
            return;
        }

        if (variantCode) {
            sendFiltersGtag(getFilterTitleForGtag([], filter));

            const {pathName} = filterInstance.userAddOneFilterValue(filter, variantCode);
            pushRoute(pathName, undefined, {scroll: false, shallow: true});
        }
    }, [filterInstance, variantCode, sendFiltersGtag, filter, pushRoute]);

    const handleDiscard = useCallback(() => {
        if (!filterInstance) {
            return;
        }

        if (variantCode) {
            sendFiltersGtag(getFilterTitleForGtag([], filter), EventAction.RemoveFilter);

            const {pathName} = filterInstance.userRemoveOneFilterValue(filter, variantCode);
            pushRoute(pathName, undefined, {scroll: false, shallow: true});
        }
    }, [filterInstance, variantCode, sendFiltersGtag, filter, pushRoute]);

    return <CheckboxAloneFactory filter={filter} onApply={handleApply} onDiscard={handleDiscard} />;
};
